// The avatar menu's Language row — the workspace shell's half (persona audit
// round 1, WL-2: giorgi and nino looked for the language and found it four
// taps deep, name → Admin → Workspace Settings → Language).
//
// The shared account menu (shared/functions/accountMenu.js) shows the row
// this builds and hands a pick back; a host that does not register these two
// shows no row.
//
//   workspaceLanguageMenuRow(root) → { key, label, children } | null
//     Only for someone who may set the WORKSPACE's language (onboardingLanguage
//     `canChange` — the org roles the admin card gates on); null for a member
//     (the workspace's language is its admins' choice) and for a host that
//     ships one language. The label names the current language ("Language:
//     English"), the children are the shipped languages by endonym, the
//     current one checked — the Theme row's shape.
//   workspaceLanguageSelect(code)
//     The ONE writer the welcome's language step uses
//     (onboardingSetWorkspaceLanguage): the per-key settings PATCH, then the
//     held record converges (setActiveWorkspaceRecord) and the shell's
//     language policy repaints the session at once — never the person's own
//     setLang.
//
// FRANK: self-contained exports; siblings through `this.call`.

export function workspaceLanguageMenuRow(root) {
  const el = this
  if (!el || typeof el.call !== 'function') return null
  const lang = el.call('onboardingLanguage', root)
  if (!lang || typeof lang !== 'object' || !lang.canChange) return null
  const choices = (Array.isArray(lang.choices) ? lang.choices : []).filter(
    (c) => c && typeof c.value === 'string' && c.value
  )
  if (choices.length < 2) return null
  const current = choices.find((c) => c.value === lang.current) || null
  const words = String(el.call('polyglot', 'workspace.menu.language') || '')
  return {
    key: 'language',
    label: words.replace('{language}', current ? String(current.label || current.value) : ''),
    children: choices.map((c) => ({
      key: 'language-' + c.value,
      action: 'workspaceLanguage',
      code: c.value,
      label: String(c.label || c.value),
      checked: c.value === lang.current
    }))
  }
}

export function workspaceLanguageSelect(code) {
  const el = this
  if (!el || typeof el.call !== 'function' || typeof code !== 'string' || !code) return false
  return el.call('onboardingSetWorkspaceLanguage', code)
}
